import { TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import NoDataLabel from "./NoDataLabel";

interface Props {
    columnsCount: number;
}

export default function NoDataRowValues ({columnsCount}: Props){
    const [noDataValues, setNoDataValues] = useState<any>([]);

    useEffect(() => {
        generateNoDataValues();
    }, [columnsCount]);

    const generateNoDataValues = () => {
        const values = [];
        for (let index = 0; index < columnsCount; index++) {
            values.push(<NoDataLabel/>);
        }

        setNoDataValues([...values]);
    } 

    return (<TableRow key={"0"}>
        {noDataValues && noDataValues.length > 0 && (
            noDataValues.map((value: any) =>  <TableCell>{value}</TableCell>)
        )}
    </TableRow>);
}